/* eslint-disable import/prefer-default-export */
import * as React from 'react';

import MotionProvider from './src/components/animation/MotionProvider';

export const wrapRootElement = ({ element }) => <MotionProvider>{element}</MotionProvider>;
